import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetMasterEventMetadataQuery } from '../api/reigniteApi'

interface UseShouldDisplayAwardsTabProps {
  masterId: number | null;
}

export function useShouldDisplayAwardsTab({ masterId }: UseShouldDisplayAwardsTabProps): { shouldDisplayAwardsTab: boolean; isLoading: boolean } {
  const { data: masterEventMetadata, isLoading } = useGetMasterEventMetadataQuery(masterId ?? skipToken);

  const shouldDisplayAwardsTab = useMemo(() => {
    return !!masterEventMetadata?.events?.some(event =>
      event?.races?.some(race =>
        race?.divisions?.some(division =>
          division?.awards?.publish && division?.awards?.depth > 0
        )
      )
    )
  }, [masterEventMetadata])

  return { shouldDisplayAwardsTab, isLoading }
}